import React, { createContext, useContext, useState } from "react";

const DefaultContext = createContext();

export const useDefaultContext = () => useContext(DefaultContext);

export const DefaultProvider = ({ children }) => {
  const [sidebarToogle, setSidebarToogle] = useState(true);

  return (
    <DefaultContext.Provider value={{sidebarToogle, setSidebarToogle}}>
      {children}
    </DefaultContext.Provider>
  );
};